<template>
  <div>
    <el-form-item label="优化目标">
      <!-- 单条修改计划是全局禁用 -->
      <OptimizationGoals
        v-model="budgetForm.optimization_goal"
        :global-disabled="pageStates.isUpdate || pageStates.isModify"
        :positive-goal="budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.goal"
        :plan-form="planForm"
        @change="onOptimizationGoalChange"
      >
        <template v-slot:backflow v-if="enableBackFlow">
          <!-- 腾讯广告3.0应用平台为小游戏且子目的为回流触达才能选择【沉默唤起】优化目标 -->
          <!-- 腾讯广告搜索广告应用平台为小游戏才能选择【沉默唤起】优化目标 -->
          <el-radio-button ghost :label="OPT_GOAL.BACK_FLOW" :disabled="backFlowDisabled">沉默唤起 </el-radio-button>
        </template>
        <template v-slot:reserve>
          <el-radio-button
            ghost
            :label="OPT_GOAL.OPTIMIZATIONGOAL_PAGE_RESERVATION"
            :disabled="planForm.marketing_sub_goal !== MARKETING_SUB_GOAL.NEW_GAME_RESERVE"
          >
            预约表单
          </el-radio-button>
          <el-radio-button
            class="last-collapse-radio-button"
            ghost
            :label="OPT_GOAL.OPTIMIZATIONGOAL_CANVAS_CLICK"
            :disabled="planForm.marketing_sub_goal !== MARKETING_SUB_GOAL.NEW_GAME_RESERVE"
          >
            预约跳转点击
          </el-radio-button>
        </template>
      </OptimizationGoals>
    </el-form-item>

    <!-- 自动出价、最大转化量投放 不显示出价 -->
    <el-form-item label="出价" prop="bid_amount" v-if="!dailyBudgetDisabled">
      <el-radio-group v-model="budgetForm.bid_range">
        <el-radio-button ghost :label="0">固定出价</el-radio-button>
        <el-radio-button ghost :label="1">随机出价</el-radio-button>
      </el-radio-group>

      <div class="bid-input mt-6px">
        <el-input
          v-if="budgetForm.bid_range === 0"
          v-model="budgetForm.bid_amount"
          @blur="clearValidate"
          style="width: 220px"
          placeholder="输入价格"
        >
          <span slot="suffix">
            <span>{{ bidUnit(budgetForm.optimization_goal) }}</span>
          </span>
        </el-input>

        <InputRange v-else class="mt-6px" v-model="budgetForm.bid_num_range" placeholder="金额">
          <span slot="suffix">{{ bidUnit(budgetForm.optimization_goal) }}</span>
        </InputRange>
      </div>
    </el-form-item>
    <el-form-item label="控制成本" prop="custom_cost_cap" v-if="budgetForm.bid_scene === BID_SCENE.NORMAL_MAX">
      <div>
        <el-switch
          v-model="budgetForm.cost_constraint_scene"
          @change="clearValidate"
          :disabled="pageStates.isUpdate"
          :active-value="COST_CONTROL.OPEN"
          :inactive-value="COST_CONTROL.CLOSE"
        ></el-switch>
        <el-tooltip class="item" effect="dark" placement="top">
          <span slot="content" style="display: inline-block; width: 320px">
            建议在对优质计划提高预算后，成本预估超出预期或者预估成本不够准确时再填写成本上限；<br />
            填写的成本会影响计划实际的获量能力，建议按照所能接受的最大成本填写，此成本不支持赔付。
          </span>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>

      <el-input
        style="width: 220px"
        v-model="budgetForm.custom_cost_cap"
        v-if="budgetForm.cost_constraint_scene === 'COST_CONSTRAINT_SCENE_OPEN'"
        placeholder="输入成本"
        :disabled="pageStates.isUpdate"
      >
        <template slot="suffix">{{ bidUnit(budgetForm.optimization_goal) }}</template>
      </el-input>
    </el-form-item>

    <el-form-item label="深度转化优化" v-if="showDeepConversion">
      <el-switch :disabled="pageStates.isUpdate" v-model="budgetForm.deep_bid_mode" @change="onDeepConversionSwitchChange"></el-switch>
    </el-form-item>

    <template v-if="budgetForm.deep_bid_mode && showDeepConversion">
      <el-form-item label="深度优化类型">
        <el-radio-group :disabled="pageStates.isUpdate || deepBidDisabled" v-model="budgetForm.deep_conversion_spec.deep_conversion_type">
          <el-radio-button ghost :label="DEEP_CONVERSION_TYPE.BEHAVIOR">优化转化行为</el-radio-button>
          <el-radio-button ghost :label="DEEP_CONVERSION_TYPE.WORTH">优化ROI</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="深度目标出价">
        <el-radio-group
          v-if="budgetForm.deep_conversion_spec.deep_conversion_type === DEEP_CONVERSION_TYPE.WORTH"
          v-model="budgetForm.deep_conversion_spec.deep_conversion_worth_spec.goal"
          :disabled="pageStates.isUpdate || deepBidDisabled"
        >
          <el-radio-button ghost v-for="goal in worthGoalList" :key="goal.value" :label="goal.value">
            {{ goal.label }}
          </el-radio-button>
        </el-radio-group>

        <OptimizationGoals
          v-else
          v-model="budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.goal"
          :positive-goal="budgetForm.optimization_goal"
          :global-disabled="pageStates.isUpdate"
          :plan-form="planForm"
          deep
        >
        </OptimizationGoals>
      </el-form-item>

      <!-- 最大转化量投放时不显示出价 -->
      <template v-if="budgetForm.deep_conversion_spec.deep_conversion_type === DEEP_CONVERSION_TYPE.BEHAVIOR && !dailyBudgetDisabled">
        <el-form-item label="出价" prop="deep_bid_amount">
          <el-radio-group
            :disabled="pageStates.isUpdate"
            v-model="budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.deep_bid_range"
          >
            <el-radio-button ghost :label="0">固定出价</el-radio-button>
            <el-radio-button ghost :label="1">随机出价</el-radio-button>
          </el-radio-group>

          <div class="bid-input mt-6px">
            <InputRange
              v-if="budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.deep_bid_range"
              class="mt-6px"
              v-model="budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.deep_deepbid_num_range"
              placeholder="金额"
            >
              <span slot="suffix">{{ bidUnit(budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.goal) }}</span>
            </InputRange>

            <el-input
              v-else
              :disabled="pageStates.isUpdate"
              v-model="budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.bid_amount"
              placeholder="输入价格"
              style="width: 220px"
            >
              <span slot="suffix">
                <span>{{ bidUnit(budgetForm.deep_conversion_spec.deep_conversion_behavior_spec.goal) }}</span>
              </span>
            </el-input>
          </div>
        </el-form-item>
      </template>

      <template v-else>
        <!-- 最大转化量投放时不显示roi出价 -->
        <el-form-item v-if="!dailyBudgetDisabled" prop="deep_roi" label="深度ROI系数">
          <div class="bid-input mt-6px">
            <el-input
              :disabled="pageStates.isUpdate"
              v-model="budgetForm.deep_conversion_spec.deep_conversion_worth_spec.expected_roi"
              placeholder="输入roi系数"
            >
            </el-input>
          </div>
        </el-form-item>
      </template>
    </template>
  </div>
</template>

<script>
import BUDGET_CONST from '@/views/create/gdt/model/budget/budget-const.js'
import { MARKETING_SUB_GOAL, AD_MARKETING_SCENE } from '@/views/create/gdt/model/project-const.js'
import { projectComputedMethods } from '@/views/create/gdt/model/project-mixins.js'

import OptimizationGoals from './opt-goals.vue'
import InputRange from '@/views/edit/kuaishou/components/input-range'

export default {
  props: {
    value: Object,
    planForm: Object
  },
  components: { OptimizationGoals, InputRange },
  inject: ['parentInstance'],
  data() {
    return {
      // OPT_GOAL
      // DEEP_CONVERSION_TYPE
      ...BUDGET_CONST,
      MARKETING_SUB_GOAL
    }
  },
  computed: {
    // pageStates
    ...projectComputedMethods,
    budgetForm: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    dailyBudgetDisabled() {
      const { bid_scene, smart_bid_type } = this.budgetForm
      const isNormalMax = bid_scene === BUDGET_CONST.BID_SCENE.NORMAL_MAX
      const isSystematic = smart_bid_type === BUDGET_CONST.SMART_BID_TYPE.SYSTEMATIC
      // 最大转化量
      if (isNormalMax) return true
      // 自动出价
      if (isSystematic) return true
      return false
    },
    marketingSceneType() {
      const { ad_marketing_scene } = this.planForm
      return {
        version3: typeof ad_marketing_scene === 'undefined' || ad_marketing_scene === AD_MARKETING_SCENE.VERSION_3,
        version_smart: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SMART,
        version_search: ad_marketing_scene === AD_MARKETING_SCENE.VERSION_SEARCH
      }
    },
    /**
     * @description: 是否可以开启深度转化优化
     */
    showDeepConversion() {
      // 只有注册、激活的优化目标才显示深度转化优化
      const allowList = [BUDGET_CONST.OPT_GOAL.APP_ACTIVATE, BUDGET_CONST.OPT_GOAL.APP_REGISTER]
      // 小程序平台允许首次付费开启深度
      // 小程序平台允许沉默唤起 20250922
      if (this.parentInstance.isMiniProgram) {
        allowList.push(BUDGET_CONST.OPT_GOAL.FIRST_PURCHASE, BUDGET_CONST.OPT_GOAL.BACK_FLOW)
      }
      return allowList.includes(this.budgetForm.optimization_goal)
    },
    enableBackFlow() {
      if (this.parentInstance.isMiniProgram) {
        // 腾讯广告v3广告只有小程序的子目的是回流触达才显示
        if (this.marketingSceneType.version3) {
          return this.planForm.marketing_sub_goal === MARKETING_SUB_GOAL.RETURN_CUSTOMER_ENGAGEMENT
        }
        // 搜索广告小程序可以显示
        if (this.marketingSceneType.version_search) return true
      }

      return false
    },
    deepBidDisabled() {
      // 小程序回流触达深度优化类型和深度优化出价禁用
      return this.enableBackFlow && this.budgetForm.optimization_goal === BUDGET_CONST.OPT_GOAL.BACK_FLOW
    },
    /**
     * @description: 深度ROI目标可选列表，变现ROI 仅在优化目标=注册时可选
     */
    worthGoalList() {
      // 变现ROI 七日/30天 暂不支持，隐藏
      const hiddenMonetization = [
        BUDGET_CONST.OPT_GOAL.SEVEN_DAY_MONETIZATION_ROAS,
        BUDGET_CONST.OPT_GOAL.THIRTY_DAY_MONETIZATION_ROAS
      ]
      const list = BUDGET_CONST.OPT_ROI_GOAL_LIST.filter(
        (goal) => !hiddenMonetization.includes(goal.value)
      )
      const isRegister = this.budgetForm.optimization_goal === BUDGET_CONST.OPT_GOAL.APP_REGISTER
      if (isRegister) return list
      // 非注册：只保留付费ROI（再过滤掉首日变现ROI）
      return list.filter(
        (goal) => goal.value !== BUDGET_CONST.OPT_GOAL.ONE_DAY_MONETIZATION_ROAS
      )
    }
  },
  methods: {
    onOptimizationGoalChange(goal) {
      const newForm = { ...this.budgetForm }
      // 默认 [注册、激活] 优化目标才显示深度转化优化
      // 小程序 [首次付费] 优化目标开启深度优化
      if (!this.showDeepConversion) {
        newForm.deep_bid_mode = false
      }

      const groups = [
        {
          goal: BUDGET_CONST.OPT_GOAL.APP_REGISTER,
          deepType: BUDGET_CONST.DEEP_CONVERSION_TYPE.BEHAVIOR,
          deepGoal: BUDGET_CONST.OPT_GOAL.FIRST_PURCHASE
        },
        {
          goal: BUDGET_CONST.OPT_GOAL.FIRST_PURCHASE,
          deepType: BUDGET_CONST.DEEP_CONVERSION_TYPE.BEHAVIOR,
          deepGoal: BUDGET_CONST.OPT_GOAL.APP_REGISTER
        },
        {
          goal: BUDGET_CONST.OPT_GOAL.BACK_FLOW,
          deepType: BUDGET_CONST.DEEP_CONVERSION_TYPE.WORTH,
          deepGoal: BUDGET_CONST.OPT_GOAL.ONE_DAY_PURCHASE_ROAS
        }
      ]
      const { deepGoal, deepType } = groups.find((g) => g.goal === goal) || {}
      // 切换优化目标时，如果开启了深度优化，深度优化目标也做对应的切换
      if (deepGoal && newForm.deep_bid_mode) {
        newForm.deep_conversion_spec.deep_conversion_type = deepType
        newForm.deep_conversion_spec.deep_conversion_behavior_spec.goal = deepGoal
      }

      this.budgetForm = newForm
    },
    /**
     * @description: 切换深度转化开关
     */
    onDeepConversionSwitchChange(value) {
      const newForm = { ...this.budgetForm }
      // 开启深度
      if (value) {
        const { APP_REGISTER, FIRST_PURCHASE, BACK_FLOW, ONE_DAY_PURCHASE_ROAS } = BUDGET_CONST.OPT_GOAL

        let goal = ''
        if (this.parentInstance.isMiniProgram) {
          // 如果是小程序 优化目标为【首次付费】深度优化转化行为切换到【注册】
          if (newForm.optimization_goal === APP_REGISTER) {
            goal = FIRST_PURCHASE
          }
          // 如果是小程序 优化目标为【注册】深度优化转化行为切换到【首次付费】
          if (newForm.optimization_goal === FIRST_PURCHASE) {
            goal = APP_REGISTER
          }
          // 如果是小程序 优化目标为【沉默唤起】深度优化转化行为切换到【首次付费】
          if (newForm.optimization_goal === BACK_FLOW) {
            goal = FIRST_PURCHASE
          }
        } else {
          // 其他的切换到【首次付费】
          goal = FIRST_PURCHASE
        }
        newForm.deep_conversion_spec.deep_conversion_behavior_spec.goal = goal
        // 优化ROI切换到[首日付费ROI]
        newForm.deep_conversion_spec.deep_conversion_worth_spec.goal = ONE_DAY_PURCHASE_ROAS
      } else {
        // 关闭时清空
        newForm.deep_conversion_spec.deep_conversion_behavior_spec.goal = ''
        newForm.deep_conversion_spec.deep_conversion_worth_spec.goal = ''
      }

      this.budgetForm = newForm
    },

    bidUnit(goal) {
      // roi 类型不显示
      const { DEEP_CONVERSION_TYPE, budgetForm } = this
      if (budgetForm.deep_conversion_spec.deep_conversion_type === DEEP_CONVERSION_TYPE.WORTH) {
        return ''
      }
      const { label } = BUDGET_CONST.OPT_GOAL_LIST.find((g) => g.value === goal) || {}
      return label ? `元/${label}` : ''
    },
    clearValidate() {
      this.parentInstance?.$refs?.bidForm?.clearValidate()
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin mt-6px {
  margin-top: 6px;
}
.mt-6px {
  @include mt-6px;
}

// 为因为容器宽度导致的换行而无法共用上一个button边框添加左边框样式
.last-collapse-radio-button {
  border-left: 1px solid #e6ebf5;
}
</style>
